import Search from './Search';
import './Search.scss';
export default Search;
